// extracted by mini-css-extract-plugin
module.exports = {"info":"Info_info__3T996"};